import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MeasuresPipe } from './measures.pipe';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    MeasuresPipe,
  ],
  exports: [
    MeasuresPipe,
  ],
})
export class MeasuresModule { }
